import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";
import { ConfigType } from "@companion-core/shared/app/Interfaces/config";
import { CONFIG_TYPE } from "@companion-core/shared/app/Constants/config";

interface ConfigState {
  config: Record<string, any> | null;
  branding: Record<string, any> | null;
  publicConfig: Record<string, any> | null;
  forms: Record<string, any> | null;
  failure: Record<string, boolean> | null;
  fetching: Record<string, boolean> | null;
  interceptorLoaded: boolean;
  deepLinkPrefix: string | null;
  universalLinkPrefix: string | null;
  storeRedirection: string | null;
}

interface ConfigActions {
  setConfig: (config: Record<string, any>) => void;
  setBranding: (config: Record<string, any>) => void;
  setPublicConfig: (publicConfig: Record<string, any>) => void;
  addForm: (name: string, content: Record<string, any>) => void;
  setFailure: (value: boolean, id?: ConfigType) => void;
  setFetching: (value: boolean, id?: ConfigType) => void;
  setInterceptorLoaded: (interceptorLoaded: boolean) => void;
  setDeepLinkPrefix: (deepLinkPrefix: string) => void;
  setUniversalLinkPrefix: (universalLinkPrefix: string) => void;
  setStoreRedirection: (storeRedirection: string) => void;
}

export const initialState: ConfigState = {
  config: null,
  branding: null,
  publicConfig: null,
  forms: null,
  failure: null,
  fetching: null,
  interceptorLoaded: false,
  deepLinkPrefix: null,
  universalLinkPrefix: null,
  storeRedirection: null,
};

export const useConfigStore = createWithEqualityFn<ConfigState & ConfigActions>()(
  (set, get) => ({
    ...initialState,
    setConfig: (config: Record<string, unknown>) => set({ config }),
    setBranding: (branding: Record<string, unknown>) => set({ branding }),
    setPublicConfig: (publicConfig: Record<string, unknown>) => set({ publicConfig }),
    addForm: (name: string, content: Record<string, unknown>) => {
      set({ forms: { ...get().forms, [name]: content } });
    },
    setFailure: (value: boolean, id: ConfigType = CONFIG_TYPE.CONFIG) =>
      set({ failure: { ...get().failure, [id]: value } }),
    setFetching: (value: boolean, id: ConfigType = CONFIG_TYPE.CONFIG) =>
      set({ fetching: { ...get().fetching, [id]: value } }),
    setInterceptorLoaded: (interceptorLoaded: boolean) => set({ interceptorLoaded }),
    setDeepLinkPrefix: (deepLinkPrefix: string) => set({ deepLinkPrefix }),
    setUniversalLinkPrefix: (universalLinkPrefix: string) => set({ universalLinkPrefix }),
    setStoreRedirection: (storeRedirection: string) => set({ storeRedirection }),
  }),
  shallow,
);
